const number = {
  bind(el, {value}) {
    //必须输入为数字
    //传参为数组 [最小值，最大值，是否修改0显示为无] 限制最大最小值

    // const inputel=el.querySelector('input');


    const input = el.getElementsByTagName('input')[0]
    input.onkeyup = function (e) {
      input.value = value.replace(/[^\d.]/g, ' ');

      // input.value=input.value.replace(/[^0-9.]/g, '')

      trigger(input, 'input')
    }
    input.onblur = function (e) {
      // if (input.value<value[0]) { 暂时注释
      //     input.value=value[0]
      // }
      if (input.value > value[1]) {
        input.value = value[1]
      }
      trigger(input, 'input')
    }


  }, // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    const inputel = el.querySelector('input');
    inputel.removeEventListener('blur', el.handler)
    inputel.removeEventListener('keyup', el.handler)
  },
}
const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}

export default number



// WEBPACK FOOTER //
// ./src/common/directives/number.js